'use client';

import Script from 'next/script';
import { useLayoutEffect, useRef } from 'react';

export const trustedFormUrl = 'https://api.trustedform.com';

export function TrustedForm({
  trustedFormValue,
}: {
  trustedFormValue?: string;
}) {
  const scriptIsReady = useRef(false);
  const source = `${trustedFormUrl}/trustedform.js?provide_referrer=false&field=xxTrustedFormCertUrl&invert_field_sensitivity=false&l=${Date.now().toString()}${Math.random().toString()}`;

  useLayoutEffect(() => {
    if (!window.MutationObserver) return undefined;
    const observer = new MutationObserver(() => {
      if (!scriptIsReady.current) {
        return undefined;
      }

      const isFormReady = document.querySelector('form') as HTMLFormElement;

      const input = document.getElementsByName(
        'xxTrustedFormCertUrl',
      )[0] as HTMLInputElement | null;
      if (isFormReady && input?.value) {
        window.trustedFormCertUrlCallback(input?.value);

        observer.disconnect();
      }
      return undefined;
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return (
    <Script
      src={source}
      id="TrustedFormScript"
      data-testid="trusted-form"
      onReady={() => {
        if (!trustedFormValue) {
          scriptIsReady.current = true;
        }
      }}
    />
  );
}
